import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { AuditStatus } from '@getgreenline/homi-shared'
import { AuditFilterStore, statusOptions } from './AuditFilterStore'
import { Input, Icon, Select, Row } from 'antd'
import { BlazeButton } from '../../../../../components/CustomButtons/BlazeButton'
import { filterOption } from '../../../../../utilities/helpers'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  auditFilterStore: AuditFilterStore
}

@inject('currentCompanyStore')
@observer
export class AuditTableFilter extends Component<Props> {
  render() {
    return (
      <div id='employee-filter' className='d-flex flex-wrap white-rounded-container pb-0'>
        <Input
          className='gr-filter-item gr-filter-gutter'
          prefix={<Icon type='search' />}
          placeholder='Title'
          allowClear
          value={this.props.auditFilterStore.searchText}
          onChange={(e) => this.props.auditFilterStore.setSearchText(e.target.value)}
          onPressEnter={this.props.auditFilterStore.applyFilter}
        />

        <Select<number[] | undefined>
          className='gr-filter-item gr-filter-gutter'
          placeholder='Location'
          showArrow
          allowClear
          dropdownMatchSelectWidth={false}
          mode='multiple'
          value={this.props.auditFilterStore.filteredLocationIds}
          onChange={(locationIds) =>
            this.props.auditFilterStore.setFilteredLocationIds(locationIds)
          }
          filterOption={filterOption}
        >
          {this.props.auditFilterStore.locations.map((location) => (
            <Select.Option key={location.id} value={location.id}>
              {location.name}
            </Select.Option>
          ))}
        </Select>

        <Select<AuditStatus | undefined>
          className='gr-filter-item gr-filter-gutter'
          placeholder='Status'
          showArrow
          allowClear
          dropdownMatchSelectWidth={false}
          value={this.props.auditFilterStore.filteredStatus}
          onChange={(status) => {
            this.props.auditFilterStore.setFilteredStatus(status)
          }}
        >
          {Object.keys(statusOptions).map((optionKey) => (
            <Select.Option key={optionKey} value={optionKey}>
              {statusOptions[optionKey]}
            </Select.Option>
          ))}
        </Select>

        <Input
          className='gr-filter-item gr-filter-gutter'
          placeholder='Audit ID'
          allowClear
          value={this.props.auditFilterStore.searchId}
          onChange={(e) => this.props.auditFilterStore.setSearchId(e.target.value)}
          onPressEnter={() => this.props.auditFilterStore.applyFilter()}
        />

        <Row className='gr-filter-gutter'>
          <BlazeButton
            buttonProps={{
              type: 'primary',
              onClick: () => this.props.auditFilterStore.applyFilter(),
              loading: this.props.auditFilterStore.isLoading,
            }}
            titleProps={{ title: 'Apply' }}
          />

          <BlazeButton
            buttonProps={{
              type: 'link',
              onClick: () => this.props.auditFilterStore.resetFilter(),
              disabled: !this.props.auditFilterStore.isFiltered,
            }}
            titleProps={{ title: 'Reset' }}
          />
        </Row>
      </div>
    )
  }
}
